module.exports = __webpack_public_path__ + "img/ic_github.4c5a5695.svg";